import React from 'react'

import View from './view.js'

export default function Logic(props) {
  return <View title={props.noTitle ? null : props.text} {...props} />
}
